var $b6fb92016b740483$exports = {};
$b6fb92016b740483$exports = {
    "clear": `Golire`,
    "invalid": `(nevalid)`,
    "loading": `Se \xeencarc\u{103}...`,
    "noResults": `Niciun rezultat`,
    "valid": `(valabil)`
};


export {$b6fb92016b740483$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
